/**
 * Home Page
 * Main landing page with reading level cards
 */

import { useEffect, useRef, useState } from 'react'
import Layout from '@components/layout/Layout'
import LevelCard from '@components/home/LevelCard'
import JokeCarousel from '@components/home/JokeCarousel'
import { LEVELS_DATA } from '@data/books'

export default function Home() {
  const whatIsLines = [
    'is stuck in a book all the time.',
    'enjoys the adventures that books can take you on.',
    'is kind to their family, friends, and everyone they meet.',
  ]

  const [comboIndex, setComboIndex] = useState(0)
  const comboRef = useRef(0)

  const combinedLines = whatIsLines

  useEffect(() => {
    const timer = window.setInterval(() => {
      const next = (comboRef.current + 1) % combinedLines.length

      setComboIndex(next)
      comboRef.current = next

    }, 3600)

    return () => window.clearInterval(timer)
  }, [combinedLines.length])

  return (
    <Layout heroImage="/images/hero/hero-banner.jpg" heroAlt="RocketShip Readers">
      <div className="home-panel">
        <h1>Rocketship Readers</h1>
        <p className="home__intro">
          Welcome to rocketship readers! Choose your reading level and blast off into a world of fun adventures and exciting stories. 
          Go to the practice station to practice reading, spelling, and math. Get ready to blast off into adventure!
        </p>
        <section className="home-section home-ticker-wide" aria-live="polite">
          <h2>What makes a Rocketship Reader special?</h2>
          <div className="home-ticker home-ticker--wide">
            <span className="home-ticker__text" key={`combo-${comboIndex}`}>
              A Rocketship Reader {combinedLines[comboIndex]}
            </span>
          </div>
        </section>

        <div className="home-levels-heading">
          <h2>There are 5 levels of Rocketship Readers</h2>
        </div>

        <div className="level-grid">
          {LEVELS_DATA.map(level => (
            <LevelCard key={level.id} level={level} />
          ))}
        </div>

        <section className="home-section home-joke">
          <h2>Book Jokes that I love</h2>
          <JokeCarousel />
        </section>
        <p className="home-image-credit">I created all images with ChatGPT, except for the book covers, those are from the linked pages</p>
      </div>
    </Layout>
  )
}
